(function () {
    'use strict';

    angular.module('swif.parcauto')
    .config(['$routeProvider', function($routeProvider) {
        $routeProvider.when('/parcauto/requests/table_view', {
            templateUrl: 'partials/openstc/requests_table_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when('/parcauto/requests/explorer_view', {
            templateUrl: 'partials/openstc/requests_explorer_view.html',
            controller: 'RequestsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.request.resolveData();
                }]
            }
        });
        $routeProvider.when('/parcauto/planning', {
            templateUrl: 'partials/openstc/planning.html',
            controller: 'InterventionPlanningController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.planning.resolveData();
                }]
            }
        });
        $routeProvider.when('/parcauto/interventions/table_view', {
            templateUrl: 'partials/openstc/interventions_table_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
        $routeProvider.when('/parcauto/interventions/explorer_view', {
            templateUrl: 'partials/openstc/interventions_explorer_view.html',
            controller: 'InterventionsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifParcautoService', function (service) {
                    return service.intervention.resolveData();
                }]
            }
        });
    }]);

})();
